export const GET_TRANSACTION_PROVISION_LIST = "GET_TRANSACTION_PROVISION_LIST"
export const GET_TRANSACTION_PROVISION_LIST_SUCCESS = "GET_TRANSACTION_PROVISION_LIST_SUCCESS"
export const GET_TRANSACTION_PROVISION_LIST_FAIL = "GET_TRANSACTION_PROVISION_LIST_FAIL"

export const GET_TRANSACTION_PROVISION_SEARCH = "GET_TRANSACTION_PROVISION_SEARCH"
export const GET_TRANSACTION_PROVISION_SEARCH_SUCCESS = "GET_TRANSACTION_PROVISION_SEARCH_SUCCESS"
export const GET_TRANSACTION_PROVISION_SEARCH_FAIL = "GET_TRANSACTION_PROVISION_SEARCH_FAIL"

export const GET_TRANSACTION_PROVISION_LINKED_AMOUNTS ="GET_TRANSACTION_PROVISION_LINKED_AMOUNTS"
export const GET_TRANSACTION_PROVISION_LINKED_AMOUNTS_SUCCESS ="GET_TRANSACTION_PROVISION_LINKED_AMOUNTS_SUCCESS"
export const GET_TRANSACTION_PROVISION_LINKED_AMOUNTS_FAIL ="GET_TRANSACTION_PROVISION_LINKED_AMOUNTS_FAIL"

export const GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS ="GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS"
export const GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS_SUCCESS ="GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS_SUCCESS"
export const GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS_FAIL ="GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS_FAIL"

export const TRANSACTION_PROVISION_API_ERROR = "TRANSACTION_PROVISION_API_ERROR"